import React, { useState, useEffect } from "react";
import AllSeatingPageComponent from "./SeatingPageInsideComponent/AllSeatingPageComponent";
import WalkinSeatingPageComponent from "./SeatingPageInsideComponent/WalkinSeatingPageComponent";
import WaitlistSeatingPageComponent from "./SeatingPageInsideComponent/WaitlistSeatingPageComponent";
import ReservationSeatingPageComponent from "./SeatingPageInsideComponent/ReservationSeatingPageComponent";
import { Button } from "react-bootstrap";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import isEmpty from "../../../../../store/validation/is-Empty";

const SeatingPageComponent = (props) => {
  const [insidePageTab, setInsidePageTab] = useState("1");
  const pageChangeButtonClickHandler = (value) => (e) => {
    setInsidePageTab(value);
  };

  let walkData = [];
  let reservationData = [];
  let waitListData = [];
  let allData = props.data?.filter((item) => {
    return (
      item?.restaurant_id?.restaurant_name
        ?.toLowerCase()
        .includes(props.search.toLowerCase()) ||
      item?.diner_id?.toLowerCase().includes(props.search.toLowerCase()) ||
      (props?.search.toLowerCase() === "reservation" &&
        item?.service_type === "RESERVATION") ||
      (props?.search.toLowerCase() === "waitlist" &&
        item?.service_type === "SEATING" &&
        !item?.isWalkIn) ||
      (props?.search.toLowerCase() === "walkin" &&
        item?.service_type === "SEATING" &&
        item?.isWalkIn)
    );
  });

  if (props.sortBy === "Latest") {
    allData = allData?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  }
  if (props.sortBy === "Oldest") {
    allData = allData?.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
  }
  if (props.sortBy === "A-Z") {
    allData = allData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }
  if (props.sortBy === "Z-A") {
    allData = allData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  if (!isEmpty(props.filterBy)) {
    if (props?.filterBy?.status)
      allData = allData?.filter(
        (ele) => ele.diner_status === props?.filterBy?.dinerStatus
      );
    if (props?.filterBy?.pax) {
      switch (props?.filterBy?.pax) {
        case "0-2":
          allData = allData?.filter(
            (ele) =>
              0 <= ele.adult_count + ele.kids_count &&
              ele.adult_count + ele.kids_count <= 2
          );
          break;
        case "3-4":
          allData = allData?.filter(
            (ele) =>
              3 <= ele.adult_count + ele.kids_count &&
              ele.adult_count + ele.kids_count <= 4
          );
          break;
        case "5-6":
          allData = allData?.filter(
            (ele) =>
              5 <= ele.adult_count + ele.kids_count &&
              ele.adult_count + ele.kids_count <= 6
          );
          break;
        case "7-8":
          allData = allData?.filter(
            (ele) =>
              7 <= ele.adult_count + ele.kids_count &&
              ele.adult_count + ele.kids_count <= 8
          );
          break;
        case "8+":
          allData = allData?.filter(
            (ele) => ele.adult_count + ele.kids_count > 8
          );
          break;
        default:
          allData = allData;
      }
    }
  }

  for (let i = 0; i < allData.length; i++) {
    if (allData[i].service_type === "RESERVATION") {
      reservationData.push(allData[i]);
    } else if (
      allData[i].service_type === "SEATING" &&
      allData[i].isWalkIn === true
    ) {
      walkData.push(allData[i]);
    } else if (
      allData[i].service_type === "SEATING" &&
      allData[i].isWalkIn === false
    ) {
      waitListData.push(allData[i]);
    }
  }

  // useEffect(() => {
  //   if (props.data) {
  //     let walkData = [];
  //     let reservationData = [];
  //     let waitListData = [];

  //     for (let i = 0; i < props.data.length; i++) {
  //       if (props.data[i].service_type === "RESERVATION") {
  //         reservationData.push(props.data[i]);
  //       } else if (
  //         props.data[i].service_type === "SEATING" &&
  //         props.data[i].isWalkIn === true
  //       ) {
  //         walkData.push(props.data[i]);
  //       } else if (
  //         props.data[i].service_type === "SEATING" &&
  //         props.data[i].isWalkIn === false
  //       ) {
  //         waitListData.push(props.data[i]);
  //       }
  //     }

  //     setReservation(reservationData);
  //     setWaitList(waitListData);
  //     setWalkIn(walkData);
  //   }
  // }, [props.data]);

  // useEffect(() => {
  //   if (props.search) {
  //     let walkData = [];
  //     let reservationData = [];
  //     let waitListData = [];
  //     let allD = [];
  //     allD = allData.filter((item) => {
  //       return (
  //         (item && item.restaurant_id?.restaurant_name.toLowerCase().includes(props.search.toLowerCase()))
  //       );
  //     });
  //     setReservation(reservationData);
  //     setWaitList(waitListData);
  //     setWalkIn(walkData);
  //     setAllData(allD);
  //   }
  // }, [props.search])

  return (
    <React.Fragment>
      {props.tempAddRemoveLoader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="row super_admin_all_users_toggle_button-tab">
            <div className="col-9 super_admin_all_users_toggle_button-tab">
              <div className="Right-side-heading-text ml-0">
                <div className="d-flex align-items-center">
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      insidePageTab === "1" ? "active" : ""
                    }`}
                    onClick={pageChangeButtonClickHandler("1")}
                  >
                    All
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      insidePageTab === "2" ? "active" : ""
                    }`}
                    onClick={pageChangeButtonClickHandler("2")}
                  >
                    Walk-In
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      insidePageTab === "3" ? "active" : ""
                    }`}
                    onClick={pageChangeButtonClickHandler("3")}
                  >
                    Waitlist
                  </Button>
                  <Button
                    variant="link"
                    className={`px-0 mr-4 text-grayLink f12-500 ${
                      insidePageTab === "4" ? "active" : ""
                    }`}
                    onClick={pageChangeButtonClickHandler("4")}
                  >
                    Reservation
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 p-0">
            {insidePageTab === "1" && (
              <AllSeatingPageComponent
                diners={allData}
                insidePageTab={insidePageTab}
                search={props.search}
                getData={props.getData}
              />
            )}
            {insidePageTab === "2" && (
              <WalkinSeatingPageComponent
                diners={walkData}
                insidePageTab={insidePageTab}
                getData={props.getData}
              />
            )}
            {insidePageTab === "3" && (
              <WaitlistSeatingPageComponent
                diners={waitListData}
                insidePageTab={insidePageTab}
                getData={props.getData}
              />
            )}
            {insidePageTab === "4" && (
              <ReservationSeatingPageComponent
                diners={reservationData}
                insidePageTab={insidePageTab}
                getData={props.getData}
              />
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

SeatingPageComponent.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  tempAddRemoveLoader: state.userManagement.tempAddRemoveLoader,
});

export default connect(mapStateToProps, null)(SeatingPageComponent);
